/*eslint-disable */

'use strict';
$(function () {
    var P = require('./main.js');

    if (window.DISPLAY_INVITE_POPUP) {
        setTimeout(() => {
            $("#js-accept-org-invite").click()
        }, 500)
    }

    let basePath= '/accounts';
    if (typeof DEV_MODE !== "undefined" && DEV_MODE) {
        basePath = "";
    }
    const confirmInvitePath = basePath + '/confirm-org-invite/';
    const rejectInvitePath = basePath + '/reject-org-invite/';
    const confirmMessage = gettext("You've been invited to join ") + $(".invites_container").data('org-name') + gettext(" by ") + $(".invites_container").data('org-admin-name') + ".\n" + gettext('By accepting this invitation your Pipl account will be moved to ') + $(".invites_container").data('org-name') + "."
    
    new P.ModalConfirm({
        path: function () {
            return confirmInvitePath + this._clicked.data("invite-id") + "/";
        },
        title: gettext('Move your account to a new organization'),
        message: confirmMessage,
        triggerElement: $('#js-accept-org-invite'),
        onSuccessSubmit: function () {
            window.location.reload()
        },
        buttons: {
            confirm: {
                label: gettext("Yes"),
                className: "btn-primary btn btn-lg pull-left"
            }
        },
    });
    new P.ModalConfirm({
        path: function () {
            return rejectInvitePath + this._clicked.data("invite-id") + "/";
        },
        title: gettext('Move your account to a new organization'),
        message: gettext('Are you sure you want to dismiss the invite?'),
        triggerElement: $('#js-reject-org-invite'),
        onSuccessSubmit: function () {
            $(".invites_container").hide()
        },
        buttons: {
            confirm: {
                label: gettext("Yes"),
                className: "btn-primary btn btn-lg pull-left"
            }
        },
    });
    
    new P.ModalForm({
        path:"edit/",
        title:gettext("Edit Profile"),
        triggerElement:$('#js-edit-profile'),
        formContainer:$('#js-updateprofileform'),
        onSuccessSubmit: function(form, data) {
            $("#js-profile-name").text(form.find("#id_first_name").val() + ' ' + form.find("#id_last_name").val());
            $('.o-loginuser__title').text('✾' + form.find("#id_first_name").val())
        },
        validatorConfig: {
            rules: {
                first_name: {
                    required: true,
                    minlengthtrim: 1,
                    maxlength:30
                },
                last_name: {
                    required: true,
                    minlengthtrim: 1,
                    maxlength:30
                }
            },
            messages: {
                first_name: {
                    required: gettext("First name is required")
                },
                last_name: {
                    required: gettext("Last name is required")
                }
            }
        }
    });

    new P.ModalForm({
        path:"../password/",
        title:gettext("Change Password"),
        triggerElement:$('#js-change-pwd'),
        formContainer:$('#js-changepasswordform'),
        validatorConfig: {
            rules: {
                password_current: {
                    required: true
                },
                password_new: {
                    required: true,
                    minlengthtrim: 6,
                    maxlength:128
                },
                password_new_confirm: {
                    equalTo: "#id_password_new"
                }
            },
            messages: {
                password_current: {
                    required: gettext("Current password is required")
                },
                password_new: {
                    minlength: gettext("Password rust be at least 6 characters")
                },
                password_new_confirm: {
                    equalTo: gettext("Please repeat the same password")
                }
            }
        }
    });
});

